import { render, staticRenderFns } from "./ChildButton.vue?vue&type=template&id=201668de&scoped=true&"
import script from "./ChildButton.vue?vue&type=script&lang=js&"
export * from "./ChildButton.vue?vue&type=script&lang=js&"
import style0 from "./ChildButton.vue?vue&type=style&index=0&id=201668de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201668de",
  null
  
)

export default component.exports